import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { FaqEndpoint, Url } from "../../Type/BaseUrl";

const FaqService = createApi({
	reducerPath: "FaqService",
	baseQuery: fetchBaseQuery({
		baseUrl: Url,
	}),
	endpoints: (builder) => {
		return {
			faqsContent: builder.query({
				query: (name) => {
					return {
						url: `${FaqEndpoint}?type=${name ? name : ""}`,
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useFaqsContentQuery } = FaqService;
export default FaqService;
